import { useEffect, useMemo } from "react";
import "./RecordingPlayer.css";

const readParam = (key) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key) || "";
};

const RecordingPlayer = () => {
  const src = useMemo(() => readParam("src"), []);
  const name = useMemo(() => readParam("name") || "Recording", []);

  useEffect(() => {
    document.title = name;
  }, [name]);

  if (!src) {
    return (
      <div className="rec-player-empty">
        <div>Recording URL is missing.</div>
      </div>
    );
  }

  return (
    <div className="rec-player-root">
      <div className="rec-player-header" title={name}>
        <span className="rec-player-title">{name}</span>
      </div>
      <div className="rec-player-stage">
        <video
          src={src}
          controls
          autoPlay
          controlsList="nodownload"
          className="rec-player-video"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default RecordingPlayer;
